import axiosInstance from "./axios";

export const mealsCalendarFetcher = async (nutritionPlanId) =>
  axiosInstance
    .get("/clients/client-nutrition-program-calendar-handler", {
      params: { nutritionPlanId },
    })
    .then((response) => response.data);

export const mealsFetcher = (nutritionPlanId, mealIndex, viewSpecialMeals) =>
  axiosInstance
    .get("/clients/client-nutrition-plan-meals-handler", {
      params: {
        nutritionPlanId: nutritionPlanId,
        mealIndex: mealIndex,
        viewSpecialMeals,
      },
    })
    .then((response) => response.data);

export const saladOptionsFetcher = (nutritionPlanId) =>
  axiosInstance
    .get("/clients/salad-options-data", {
      params: { nutritionPlanId },
    })
    .then((response) => response.data);

export const fruitOptionsFetcher = (nutritionPlanMealItemId) =>
  axiosInstance
    .get("/clients/fruits-options-data", {
      params: { nutritionPlanMealItemId },
    })
    .then((response) => response.data);
